/**
 * GDPR data-export API client (Phase 2 — Q2).
 *
 * Endpoints under /api/data-export/:
 *   POST   request/                 — kick off a new export
 *   GET    list/                    — list current user's exports
 *   GET    download/{token}/        — stream the ZIP (handled outside apiService)
 */

import { apiService, api } from './api'

export const dataExportAPI = {
  request: ({ scope = 'account', include_files = true } = {}) =>
    apiService.post('/data-export/request/', { scope, include_files }),

  list: () => apiService.get('/data-export/list/'),

  /**
   * Trigger a browser download of the archive. Uses the same axios instance
   * (so auth + workspace switching cookies travel along) but as a blob.
   */
  download: async (token) => {
    try {
      const response = await api.get(`/data-export/download/${token}/`, {
        responseType: 'blob',
      })
      const blob = new Blob([response.data], { type: 'application/zip' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `ovacs_export_${token.slice(0, 8)}.zip`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      return { success: true }
    } catch (e) {
      return { success: false, error: e?.message || 'Download failed' }
    }
  },
}

export default dataExportAPI
